import { useCallback, useEffect, useState } from 'react';
import type { IEPGAsset } from 'models';
import { useApis } from 'contexts/ApisContext';

export const useEpg = (channelId?: string | null) => {
  const { epg } = useApis();
  const [epgContent, setEpgContent] = useState<IEPGAsset>();
  const [nextEpgContent, setNextEpgContent] = useState<IEPGAsset>();

  useEffect(() => {
    let cleanup = () => {
      // placeholder
    };

    setEpgContent(undefined);
    setNextEpgContent(undefined);

    if (!channelId) {
      return;
    }

    epg
      .onEpgChangeAtChannel(channelId, (asset, nextAsset) => {
        setEpgContent(asset);
        setNextEpgContent(nextAsset);
      })
      .then((cancelEpgListener) => {
        cleanup = cancelEpgListener;
      });

    return () => {
      cleanup();
    };
  }, [epg, channelId]);

  const activateNextAsset = useCallback(
    () => {
      setEpgContent(nextEpgContent);
      setNextEpgContent(undefined);
    },
    [nextEpgContent],
  );

  return {
    activateNextAsset,
    epgContent,
  };
};

export const isScheduledAsset = (asset: IEPGAsset | undefined): asset is (IEPGAsset & { startTime: number }) => {
  return Boolean(asset?.startTime);
};
